// angular
import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingBarModule, LoadingBarService } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// components
import { HeaderComponent } from '@app/layout/components/header/header.component';
import { FooterComponent } from '@app/layout/components/footer/footer.component';
import { ChatBoxComponent } from '@app/+chat/chat-box.component';
// services
import { LayoutService } from './shared/services/layout.service';
import { OrderQuickAccessComponent } from '@app/core/components/order-quick-access/order-quick-access.component';

@Component({
  selector: 'pwj-layout',
  standalone: true,
  imports: [
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    ChatBoxComponent,
    LoadingBarModule,
    LoadingBarRouterModule,
    OrderQuickAccessComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnInit {
  public isShadow: boolean = false;
  public loadingBarValue: number = 0;

  // dependencies
  private readonly _layoutService = inject(LayoutService);
  private readonly _loadingBar = inject(LoadingBarService);
  private readonly _cd = inject(ChangeDetectorRef);

  constructor() {
    // control window shadow functionality
    effect(() => {
      this.isShadow = this._layoutService.windowIsOpen();
      this._cd.detectChanges();
    });
  }

  ngOnInit(): void {
    // handle routing navigation loading bar
    this._loadingBar.value$.subscribe(value => {
      this.loadingBarValue = value;
    });
  }

  public closeBox() {
    this._layoutService.windowIsOpen.set(false);
    this._layoutService.hiddenAdvancedFilters.set(true);
    this._layoutService.hiddenProfileMenu.set(true);
  }
}
